import {
  Alert,
  Box,
  CircularProgress,
  Snackbar,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import "reactflow/dist/style.css";
import SliderBarMaps_ from "../../../../componentes/easyMaps/sideBarEasyMaps";
import api from "../../../../services/apiPublic";
import { useEffect, useMemo, useRef, useState } from "react";
import { useNavigate, useOutletContext, useParams } from "react-router-dom";
import ReactFlowMapas from "./reactFlowMapa";
import AlertModal_ from "../../../../componentes/alertModal";
import LoadingUpdate_ from "../../../../componentes/easyMaps/loadingUpdate";
import { MapaContext, SnackbarState } from "../../../../contexts/mapaContext";
import ToastAlert from "../../../../componentes/easyMaps/toastAlert";
import { ToastContainer } from "react-toastify";
import { network } from "../../../../schemas/elements";

const SliderBarMaps = SliderBarMaps_ as any;
const LoadingUpdate = LoadingUpdate_ as any;
const AlertModal = AlertModal_ as any;

interface AlertModalPublicState {
  open: boolean;
  severity?: string;
  text?: string;
  buttonText?: string;
  buttonCancelText?: string;
}

interface IMapConnection extends network.monitor.IConnection {
  config?: ConnectionConfig;
  entangled?: boolean;
  destinationId?: string;
  referenceId?: string;
  [key: string]: unknown;
}

interface XYZoom {
  x: number;
  y: number;
  zoom: number;
}

const MapaTopologiaPublic = () => {
  const [snackbar, setSnackbar] = useState<SnackbarState | null>(null);
  const [produtos] = useState<any>(false);
  const theme = useTheme();
  const [map, setMap] = useState<any>({});
  const [configurationMap, setConfigurationMap] = useState<any | null>(null);
  const [elements, setElements] = useState<Map<string, MapElement>>(new Map());
  const [elementSelected, setElementSelected] = useState<MapElement | null>(
    null,
  );
  const [connections, setConnections] = useState<Map<string, IMapConnection>>(
    new Map(),
  );
  const [connectionsAnalog] = useState<IMapConnection[]>([]);
  const [connectionSelected, setConnectionSelected] =
    useState<IMapConnection | null>(null);
  const [edgeSelected, setEdgeSelected] = useState<any>(null);
  const [checkChanges, setCheckChanges] = useState<boolean>(false);
  const [elementsConnected, setElementsConnected] = useState<any[] | null>([]);
  const [fullScreem, setFullScreem] = useState<boolean>(false);
  const [iconsElements, setIconsElements] = useState<MapImage[]>([]);
  const [openRightBar, setOpenRightBar] = useState<boolean>(false);
  const [mapas, setMapas] = useState<
    { nome: string; id: string; tipo: string }[]
  >([]);
  const [sinc, setSinc] = useState<boolean>(false);
  const sincRef = useRef<boolean>(false);
  const [focusNodeId, setFocusNodeId] = useState<string | null>(null);
  const [coordenadasFlow, setCoordenadasFlow] = useState<{
    x: number;
    y: number;
  } | null>(null);
  const [loadingMap, setLoadingMap] = useState<boolean>(true);
  const [loadinButtonEnlace] = useState<boolean>(false);
  const [openAlertModal, setOpenAlertModal] = useState<AlertModalPublicState>({
    open: false,
  });
  const [collapse, setCollapse] = useState<boolean>(false);
  const [lastCollectData, setLastCollectData] = useState<any>(null);

  // atualização otimização
  const [hostsDataMap, setHostsDataMap] = useState<
    Map<string, network.monitor.IHost[]>
  >(new Map());
  const [alertsDataMap, setAlertsDataMap] = useState<
    Map<string, network.monitor.IAlert[]>
  >(new Map());
  const [connectionsDataMap, setConnectionsDataMap] = useState<
    Map<string, IMapConnection>
  >(new Map());
  const [configElementDataMap, setConfigElementDataMap] = useState<
    Map<string, network.monitor.IConfig>
  >(new Map());

  const [soundState, setSoundState] = useState(false);
  const [newAlerts, setNewAlerts] = useState<network.monitor.IAlert[]>([]);

  const [
    connectionsDataMapPercentTraffic,
    setConnectionsDataMapPercentTraffic,
  ] = useState(new Map());
  const [connectionsDataMapPercentPower, setConnectionsDataMapPercentPower] =
    useState(new Map());

  const navigate = useNavigate();
  const isSmall = useMediaQuery(theme.breakpoints.down("md"));

  const { id } = useParams();
  const { socket, config, configLayer, setConfigLayer } = useOutletContext<
    EasyMapsPublicLayoutContext & { socket: any }
  >();

  const isMobile =
    (navigator as any).userAgentData?.mobile === true ||
    window.matchMedia("(pointer: coarse)").matches;

  const xyZoomFromUrl: XYZoom = useMemo(() => {
    const url = new URL(window.location.href);
    const xURL = url.searchParams.get("x");
    const yURL = url.searchParams.get("y");
    const zoomURL = url.searchParams.get("zoom");

    return {
      x: xURL ? Number(xURL) : NaN,
      y: yURL ? Number(yURL) : NaN,
      zoom: zoomURL ? Number(zoomURL) : NaN,
    };
  }, []);

  const styles = {
    fullScreem: {
      position: "fixed",
      zIndex: 1500,
      width: "100dvw",
      height: "100dvh",
      left: 0,
      top: 0,
    },
    noFullScreem: {
      position: "relative",
      ml: { xs: "0px", md: collapse ? "0px" : "340px" },
      width: {
        xs: "100dvw",
        md: "calc(100dvw - " + (collapse ? "0px" : "340px") + ")",
      },
      height: { xs: "calc(100dvh - 60px)", sm: "calc(100dvh - 67px)" },
    },
    loadingMap: {
      position: "absolute",
      zIndex: 1000,
      width: "100%",
      height: "100%",
      backgroundColor: "#00000093",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      flexDirection: "column",
      gap: 4,
    },
    toastContainer: {
      zIndex: fullScreem ? 1501 : 1200,
      marginTop: (sinc || loadingMap ? 55 : 0) + (fullScreem ? 0 : 60) + "px",
      marginRight: elementSelected ? "355px" : "0",
    },
  };

  useEffect(() => {
    if (newAlerts.length === 0) return;

    newAlerts.forEach((alert, index) => {
      if (!alert.elementId) return;
      const element = elements.get(alert.elementId);

      ToastAlert({
        alert,
        focus: setFocusNodeId,
        element,
        theme,
        sound: index === 0 && soundState, // Toca o som apenas para o primeiro alerta da lista
      });
    });

    setNewAlerts([]);
  }, [newAlerts]);

  useEffect(() => {
    if (!id || !config) return;
    handleApi();
  }, [id, config]);

  useEffect(() => {
    setCollapse(isSmall);
  }, [isSmall]);

  useEffect(() => {
    if (!id || !config) return;
    // atualiza as confi de layer do mapa para o default
    if (!configLayer?.[id]) {
      setConfigLayer((prev) => ({
        ...(prev || {}),
        [id]: "trafego",
      }));
    }

    let timeInterval = config?.configuracoes?.top?.atualizacao || 60000;
    const interval = window.setInterval(() => {
      updateDataElementSocket();
    }, timeInterval);
    return () => window.clearInterval(interval);
  }, [id, config]);

  async function handleApi() {
    try {
      setLoadingMap(true);
      setElementSelected(null);
      setConnectionSelected(null);
      await Promise.all([
        handleApiGetMap(id as string),
        handleApiGetMaps(),
        handleApiGetElements(id as string),
        getIconDB(),
      ]);
    } catch (error) {
    } finally {
      setLoadingMap(false);
    }
  }

  //-----funcoes de chamada a api
  async function handleApiGetElements(id: string) {
    try {
      const response = await api.post("/easyMaps/public/element/findMany", {
        mapId: id,
      });
      if (response.data.status === "Error") {
        setSnackbar({
          children: "Error: Não foi possível buscar o mapa",
          severity: "error",
        });
      } else {
        const data = response.data;
        // transforma os elements em MAP
        let elements = new Map<string, MapElement>(
          data.responseAlerts.map((el: MapElement) => [el.id, el]),
        );
        let connections = new Map<string, IMapConnection>(
          data.connections.map((el: IMapConnection) => [el.id, el]),
        );

        setElements(elements);
        setConnections(connections);
        updateDataElementSocket();
      }
    } catch (error: any) {
      console.error(error);
      setSnackbar({
        children: `Error:${
          error?.message || "Error: Não foi possível se conectar com o servidor"
        } `,
        severity: "error",
      });
    }
  }
  async function handleApiGetMap(mapId: string) {
    try {
      const response = await api.post("/easyMaps/public/map/findMapById", {
        mapId,
      });
      if (response.data.status === "Error") {
        setSnackbar({
          children: "Error: Não foi possível buscar o mapa",
          severity: "error",
        });
      } else {
        const { ConfigMapEasyMaps, ...map } = response.data;
        setMap(map);
        if (ConfigMapEasyMaps) {
          setConfigurationMap(ConfigMapEasyMaps);
        } else {
          //usa a configurações globais
          setConfigurationMap({
            configuracoes: config?.configuracoes?.top || null,
          });
        }
      }
    } catch (error: any) {
      console.error(error);
      if (error?.response?.status == 404) navigate("/easyMaps/pages/notFound");
      if (error?.response?.status == 401)
        setOpenAlertModal({
          open: true,
          severity: "error",
          text: "Você não tem permissão para acessar este mapa, solicite permissão ao administrador",
        });
      setSnackbar({
        children: `Error:${
          error?.message || "Error: Não foi possível se conectar com o servidor"
        } `,
        severity: "error",
      });
    }
  }
  async function updateDataElementSocket() {
    if (sincRef.current) return;

    try {
      sincRef.current = true;
      setSinc(true);
      const responseBuffer = await api.get("/easyMaps/public/map/lastData", {
        params: { mapId: id },
        responseType: "arraybuffer",
      });
      sincRef.current = false;
      setSinc(false);
      setNewAlerts([]);
      if (responseBuffer.status !== 200) {
        console.error("Error na resposta da última coleta:", responseBuffer);
        setSnackbar({
          children: "Error: Não foi possível sincronizar os elementos",
          severity: "error",
        });
      } else {
        // transforma os elements proto em data
        const message = (network.monitor.ElementResponseRoot.decode as any)(
          new Uint8Array(responseBuffer.data),
        );
        const response = network.monitor.ElementResponseRoot.toObject(message, {
          defaults: true,
          longs: Number,
        });

        // trnsforma os elements em MAP
        const updatedData = response;
        const newHostsMap = new Map<string, network.monitor.IHost[]>();
        const newAlertsMap = new Map<string, network.monitor.IAlert[]>();
        const newConnectionsMap = new Map<string, IMapConnection>();
        const configElementMap = new Map<string, network.monitor.IConfig>();
        const connGroupedByPercentegeTrafego: Record<string, string[]> = {};
        const connGroupedByPercentegePotencia: Record<string, string[]> = {};

        for (const el of updatedData.elementosResponse) {
          // hosts por elemento
          if (el.hosts?.length) {
            newHostsMap.set(el.id, el.hosts);
          }

          // conexões concatenadas
          for (const conn of el.connections) {
            //trafego
            if (conn?.corTraffic?.label) {
              if (conn.corTraffic.label in connGroupedByPercentegeTrafego) {
                connGroupedByPercentegeTrafego[conn.corTraffic.label].push(
                  conn.id,
                );
              } else {
                connGroupedByPercentegeTrafego[conn.corTraffic.label] = [
                  conn.id,
                ];
              }
            }
            //potencia
            if (conn?.corPower?.label) {
              if (conn.corPower.label in connGroupedByPercentegePotencia) {
                connGroupedByPercentegePotencia[conn.corPower.label].push(
                  conn.id,
                );
              } else {
                connGroupedByPercentegePotencia[conn.corPower.label] = [
                  conn.id,
                ];
              }
            }

            newConnectionsMap.set(conn.id, conn as unknown as IMapConnection);
          }

          // alerts por elemento (ou por host, se preferir)
          if (el.alerts?.length) {
            newAlertsMap.set(el.id, el.alerts);

            // somente os novos
            const freshAlerts = el.alerts.filter(
              (alert: network.monitor.IAlert) => alert.isNew,
            );

            if (freshAlerts.length > 0) {
              setNewAlerts((prev) => {
                const existingKeys = new Set(
                  prev.map((a) => `${a.triggerid}-${a.eventid}`),
                );

                const filtered = freshAlerts.filter(
                  (a) => !existingKeys.has(`${a.triggerid}-${a.eventid}`),
                );

                return [...prev, ...filtered];
              });
            }
          }
          if (el.config) {
            configElementMap.set(el.id, el.config);
          }
        }
        setHostsDataMap(newHostsMap);
        setConfigElementDataMap(configElementMap);
        setAlertsDataMap(newAlertsMap);
        setConnectionsDataMap(newConnectionsMap);
        setLastCollectData(new Date(updatedData?.dataColeta) || null);

        // conexões agrupadas por percentual
        setConnectionsDataMapPercentTraffic(
          new Map(Object.entries(connGroupedByPercentegeTrafego)),
        );
        setConnectionsDataMapPercentPower(
          new Map(Object.entries(connGroupedByPercentegePotencia)),
        );
      }
    } catch (error) {
      sincRef.current = false;
      setSinc(false);
      console.error("Error ao atualizar os dados dos elementos:", error);
      setSnackbar({
        children: "Error: Não foi possível atualizar",
        severity: "error",
      });
    }
  }
  async function handleApiGetMaps() {
    try {
      const response = await api.get("/easyMaps/public/map/findMany");
      if (response.data.status === "Error") {
        setSnackbar({
          children: "Error: Não foi possível carregar os mapas",
          severity: "error",
        });
      } else {
        if (response.data) {
          setMapas(
            response.data.map((map: any) => ({
              nome: map?.titulo,
              id: map?.id,
              tipo: map?.tipo,
            })),
          );
        }
      }
    } catch (error: any) {
      console.error(error);
      setSnackbar({
        children: `Error:${
          error?.message || "Não foi possível se conectar com o servidor"
        } `,
        severity: "error",
      });
    }
  }

  async function getIconDB() {
    try {
      const response = await api.get("/easyMaps/public/img/findMany");
      if (response.data.status === "Error") {
        setSnackbar({
          children: "Error: Não foi possível buscar os icons",
          severity: "error",
        });
      } else {
        setIconsElements(response.data);
      }
    } catch (error: any) {
      console.error(error);
      setSnackbar({
        children: `Error:${
          error?.message || "Error: Não foi possível se conectar com o servidor"
        } `,
        severity: "error",
      });
    }
  }

  const changeConnection = (
    _edgeId: string,
    updateConfig: any,
    updateData: any,
  ) => {
    setCheckChanges(true);
    setConnectionSelected((con) => {
      return {
        ...con,
        ...updateData,
        config: {
          ...con?.config,
          ...updateConfig,
        },
      };
    });
  };

  const handleCollapse = () => {
    setCollapse(!collapse);
  };

  const handleFullscreen = (value: boolean) => {
    setFullScreem(value);
    if (!isMobile) setCollapse(value);
  };

  const addMapInMaps = (map: any) => {
    setMapas([...mapas, { nome: map?.titulo, tipo: map?.tipo, id: map?.id }]);
  };
  return (
    //Atenção: O contexto MapaContext é usado para compartilhar o estado do mapa e elementos entre os componentes filhos,
    // nas proximas atualizações usem essa forma para organizar o acesso aos dados do mapa.
    // Isso facilita a manutenção e a escalabilidade do código.
    // e Se possivel, removam os props desnecessários dos componentes filhos.
    <MapaContext.Provider
      value={{
        mapId: id,
        tipo: "top",
        elements,
        setElements,
        elementSelected,
        setElementSelected,
        connections,
        setConnections,
        connectionSelected,
        setConnectionSelected,
        editMode: false,
        setEditMode: () => {},
        checkChanges,
        setCheckChanges,
        snackbar,
        setSnackbar,
        isPublic: true,
        updateDataElementSocket,
        configurationMap,
        setConfigurationMap,
        hostsDataMap,
        alertsDataMap,
        connectionsDataMap,
        configElementDataMap,
        lastCollectData,
        connectionsDataMapPercentTraffic,
        connectionsDataMapPercentPower,
        soundState,
        setSoundState,
      }}
    >
      <ToastContainer
        style={styles.toastContainer}
        newestOnTop
        limit={isMobile ? 4 : 5}
      />
      <Stack direction="row">
        <SliderBarMaps
          map={map}
          iconsElements={iconsElements}
          elements={elements}
          setFocusNodeId={setFocusNodeId}
          collapse={collapse}
          handleCollapse={handleCollapse}
          fullscreen={fullScreem}
          isPublic={true}
        />
        <Stack sx={!fullScreem ? styles.noFullScreem : styles.fullScreem}>
          {loadingMap && (
            <Box sx={styles.loadingMap}>
              <CircularProgress size="50px" />
              <Typography fontSize="14px">
                Carregando dados do mapa...
              </Typography>
            </Box>
          )}
          <LoadingUpdate
            visible={sinc && !loadingMap}
            elementSelected={!!elementSelected}
          />
          <ReactFlowMapas
            setEdgeSelected={setEdgeSelected}
            connectionsAnalog={connectionsAnalog}
            setElementsConnected={setElementsConnected}
            connectionSelected={connectionSelected}
            setConnectionSelected={setConnectionSelected}
            iconsElements={iconsElements}
            setOpenRightBar={setOpenRightBar}
            setLoadingPage={setLoadingMap}
            focusNodeId={focusNodeId}
            fullScreem={fullScreem}
            setFullScreem={handleFullscreen}
            mapId={id}
            title={map?.titulo}
            checkChanges={checkChanges}
            setCoordenadasFlow={setCoordenadasFlow}
            setConnections={setConnections}
            edgeSelected={edgeSelected}
            coordenadasFlow={coordenadasFlow}
            elementsConnected={elementsConnected}
            openRightBar={openRightBar}
            setFocusNodeId={setFocusNodeId}
            socketCliente={socket}
            mapas={mapas}
            addMapInMaps={addMapInMaps}
            produtos={produtos}
            changeConnection={changeConnection}
            setCheckChanges={setCheckChanges}
            updateDataElementSocket={updateDataElementSocket}
            loadinButtonEnlace={loadinButtonEnlace}
            collapse={collapse}
            xyZoomFromUrl={xyZoomFromUrl}
          />
        </Stack>
      </Stack>
      <AlertModal
        openModal={openAlertModal?.open ?? false}
        setOpenModal={(data: boolean) => setOpenAlertModal({ open: data })}
        severity={openAlertModal?.severity}
        buttonText={openAlertModal.buttonText || "Voltar"}
        buttonCancelText={openAlertModal.buttonCancelText}
        textContent={openAlertModal?.text}
        handleButton={() => {
          setOpenAlertModal({ open: false });
          navigate(-1);
        }}
      />
      {!!snackbar && (
        <Snackbar
          open
          onClose={() => setSnackbar(null)}
          autoHideDuration={2000}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        >
          <Alert {...snackbar} onClose={() => setSnackbar(null)} />
        </Snackbar>
      )}{" "}
    </MapaContext.Provider>
  );
};
export default MapaTopologiaPublic;
